import React, { useState } from "react";
import { Card, Col, Row, OverlayTrigger, Popover } from "react-bootstrap";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";
import "./takemoneyinchunks.scss";
import dayjs from "dayjs";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import { useSelector } from "react-redux";
import { addCommas, formatGBP } from "../../helpers/helpers";

const TakeMoneyInChunks = (props) => {
  const { choose } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const monetoryData =
    Object.keys(choose).length === 0
      ? JSON.parse(localStorage.getItem("choose"))
      : choose;
  const choosenAmount = monetoryData?.monetaryChosenAmount;

  const [value, setValue] = useState(0);
  const [displayValue, setDisplayValue] = useState("");

  const taxFreeCash = value / 4;
  const tetaxableCash = taxFreeCash * 3;
  const currentDate = new Date();
  let todayDate = dayjs(currentDate).format("DD/MM/YYYY");
  const handleChange = (e) => {
    let input = e.target.value.replace(/[£,]/g, "").trim();
    // Allow typing a dot but don't store it unless followed by digits

    const TWO_DECIMAL_REGEX = /^\d*\.?\d{0,2}$/;

    if (
      TWO_DECIMAL_REGEX.test(input) &&
      Number(input) <= Number(choosenAmount)
    ) {
      const numericValue = Number(input);

      setDisplayValue(input);

      if (numericValue <= 0) {
        setValue("");
      } else {
        const cleanValue = input.endsWith(".") ? input.slice(0, -1) : input;
        setValue(cleanValue);
      }
    }
  };
  const handleBack = () => {
    props.makeInitialStepper(false, 33, { isRetirementChoice: true }, true);
  };
  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_TAKE_MONEY_IN_CHUNKS;
    let takeMoneyInChunks = {
      active: true,
      lumpSumAmt: Number(value),
      moneyPurchaseAnnualAllowance: true,
      submitted: true,
    };
    let payload = {
      currentStep,
      choiceCategory: { takeMoneyInChunks },
    };
    props.nextStepIndentifier(
      RA_STEPS_IDENTIFIERS.RA_TAKE_MONEY_IN_CHUNKS,
      payload // eslint-disable-line
    );
  };
  return (
    <Card className="application-step">
      <Card.Body className="take-money-in-chunks">
        <Row>
          <Col md={12} className="mb-fourty">
            <h2 className="heading">
              Take your money in chunks, a bit at a time
            </h2>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <p>
              Each time you take money from your pension pot, 25% will be tax
              free and you&apos;ll pay income tax on the other 75%.
            </p>
            <p>
              The technical pensions term that you might see for this option is
              an &apos;uncrystallised fund pension lump sum&apos;, or UFPLS for
              short.
            </p>
            <p>
              The rest of your money will stay in your pension pot and will
              continue to have the same investment choices as now.
            </p>
            <p>
              Your pension savings can go up or down in value, and if you choose
              this option, it&apos;s important to keep an eye on how your money
              is invested to make sure it continues to suit your needs.
            </p>
          </Col>
        </Row>
        <div>
          <p>I&apos;d like to take the following amount</p>
          <p>
            <input
              type="text"
              value={formatGBP(displayValue)}
              id="amount"
              min="0"
              max={Number(choosenAmount)}
              aria-describedby="amount"
              onChange={handleChange}
              className="gbp-input"
            />
          </p>
        </div>

        <div>
          <p>
            You’ll receive 25% of this tax free and pay income tax on the rest.
          </p>
        </div>
        <div className="retirement-choice">
          <div className="retiring-section">
            {" "}
            <p>Total TPT pension pot</p>
            <p>Amount withdrawn</p>
            <p>Of which tax-free cash</p>
            <p>Of which taxable cash</p>
            <p>Amount remaining in total TPT pension pot</p>
          </div>
          <div className="pot-section">
            <p>{"£" + addCommas(parseFloat(choosenAmount)?.toFixed(2))}</p>
            <p>
              {"£" +
                addCommas(
                  (isNaN(parseFloat(value)) ? 0 : parseFloat(value)).toFixed(2) //eslint-disable-line
                )}
            </p>
            <p>{"£" + addCommas(parseFloat(taxFreeCash)?.toFixed(2))}</p>
            <p>{"£" + addCommas(parseFloat(tetaxableCash)?.toFixed(2))}</p>
            <p>
              {"£" + addCommas(parseFloat(choosenAmount - value)?.toFixed(2))}
            </p>
          </div>
        </div>

        <div>
          <p>
            <i>
              Taking a portion of your pension savings will be pro-rata from
              your selected pot(s) and their underlying investments.
            </i>
          </p>
          <div className="date-txt">
            Values correct as of {todayDate}
            <OverlayTrigger
              placement="right"
              overlay={
                <Popover
                  id="popover-contained"
                  className="tooltip-popover-section"
                >
                  <Popover.Body className="tooltip-popover-body">
                    <p>
                      {" "}
                      All the values are estimates, based on the most accurate
                      information available. They include all the contributions
                      paid by you and your employer.
                    </p>
                    <p>
                      The value of your pension savings is based on current
                      financial conditions and is not guaranteed. The amounts
                      you receive may be higher or lower than the amounts shown
                      above. Payment of your pension will be subject to TPT’s
                      Trust Deed and Rules, and regulatory requirements.
                    </p>{" "}
                  </Popover.Body>
                </Popover>
              }
              flip={true}
            >
              <span className="textarea-tooltip ms-1">
                <Icons iconname="tool-tip" variant="icon-twelve-px" />
              </span>
            </OverlayTrigger>
          </div>
        </div>

        <Row className="button-container">
          <Col md={6}>
            {" "}
            <Buttons
              handleClick={handleBack}
              className="secondary back-btn"
              name="Back"
            />
          </Col>
          <Col md={6} className="text-end">
            <Buttons
              handleClick={() => handleContinue()}
              className="primary"
              name="Continue"
              disabled={value <= 0}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TakeMoneyInChunks;
